module.exports = __webpack_public_path__ + "static/media/ils-chat.5c165a9c.svg";